import tablelistApi from 'api/tablelistApi'
import authHelper from 'api/auth/helper'

export default {
  login(data) {
    if (!data) throw new Error('data is required')

    return tablelistApi.post('/auth/login', data)
  },
  register(data) {
    if (!data) throw new Error('data is required')

    return tablelistApi.post('/auth/register', data)
  },
  loginFacebook(data) {
    if (!data) throw new Error('data is required')

    return tablelistApi.post('/auth/facebook', data)
  },
  forgotPassword(data) {
    if (!data) throw new Error('data is required')

    return tablelistApi.post('/auth/forgot', data)
  },
  logout() {
    return authHelper.removeAuthToken()
  },
}



// WEBPACK FOOTER //
// ./src/api/auth/service.js